@if(user && user.firstName){
@if(!showTalentPoolListing){
<div class="grid grid-nogutter profile-modal">
  <div class="col-12 pb-3 border-bottom-1 border-gray-200 flex justify-content-between align-items-center flex-column xl:flex-row">
    <div class="avatar flex gap-3">
      <p-avatar
        [id]="isPwcEnabled ? 'pwc-profile-logo' : ''"
        [image]="isPwcEnabled ? 'assets/images/pwc-logo-profile.png' : 'assets/images/white-logo.png'"
        size="large"
        shape="circle"
      ></p-avatar>
      <div class="details">
        <h6 class="m-0 text-deep-purple-900 mb-1">{{user.firstName}} {{user.lastName}}</h6>
        @if(firm && firm.isCitizenshipStatusRequired){
          <p class="m-0 body1">{{user.profile.immigrationStatus | sentenceCase}}</p>
        }
        <p class="m-0 body1">Address: {{user.profile.contact.street}}, {{user.profile.contact.city}}, {{user.profile.contact.state}} {{user.profile.contact.zipCode}}</p>
      </div>
    </div>
    @if(!isAdminApprovalPending){
      <div class="rating">
        <p-rating (onRate)="rateUser()" [(ngModel)]="currentTenant.defaultRatings" [cancel]="false" class="cursor-default" />
        <p-button class=" ml-2" [pTooltip]="user.isFavorite ? 'Remove from favorite': 'Add to favorite'" tooltipPosition="top" (click)="favouriteUser()" [rounded]="true" [text]="true" icon="true">
          <span [class.vibrant-pink]="user.isFavorite" [class.light-grey]="!user.isFavorite" class="{{helperService.getEnvironmentName()}}-icon icon-bookmark-star-outlined"></span>
        </p-button>
      </div>
    }
  </div>
  <div class="col-12 xl:col-8 pt-3 pr-0 xl:pr-7">
    <div class="grid grid-nogutter">
      <div class="col-12 lg:col-4 xl:col-4 pb-3 px-2">
        <div class="wrap-worked flex border-round-lg justify-content-center gap-2 py-3 align-items-center">
          <span class="h5">{{user.totalProjectsTogetherCount}}</span>
          <p class="m-0 body2">
            {{'Projects Worked Together' | sentenceCase}}<br class="hidden xl:block lg:block">            
          </p>
        </div>
      </div>
      <div class="col-12 lg:col-4 xl:col-4 pb-3 pr-2">
        <div class="wrap-worked flex border-round-lg justify-content-center gap-2 py-3 align-items-center">
          <span class="h5">{{user.totalAcceptedOffersCount}}</span>
          <p class="m-0 body2">
            {{'Offers Accepted' | sentenceCase}}<br class="hidden xl:block lg:block" />
          </p>
        </div>
      </div>
      <div class="col-12 lg:col-4 xl:col-4 pb-3 pl-2">
        <div class="wrap-worked flex border-round-lg justify-content-center gap-2 py-3 align-items-center">
          <span class="h5">{{user.totalSentOffersCount}}</span>
          <p class="m-0 body2">
            {{'Offers Sent' | sentenceCase}}<br class="hidden xl:block lg:block">
          </p>
        </div>
      </div>
      <div class="col-12 pb-3">
        <span class="text-xl font-medium m-0"> Contact info </span>
      </div>
      <div class="col-12 pb-4">
        <div class="wrap-details border-1 p-3 border-gray-200 flex">
          @if(user.preferredFirstName){
            <div class="basic max-w-20rem w-full email-container">
              <span class="head text-sm font-medium m-0">Preferred First Name
              </span>
              <p class="m-0 text-base">{{user.preferredFirstName}}</p>
            </div>
          }
          <div class="basic max-w-20rem w-full email-container">
            <span class="head text-sm font-medium m-0">Email
              @if(currentUserisFMOrPM() && currentReviewerDidNotCompletedFirstStep()){
                <p-button class="edit-email-small-btn" size="small" pTooltip="Edit" tooltipPosition="top" (click)="editUserDetails(userProfileEditTypes.email)" [rounded]="true" [text]="true" icon="true">
                  <span class="{{helperService.getEnvironmentName()}}-icon icon-edit-outlined"></span>
                </p-button>
              }
            </span>
            <p class="m-0 text-base">{{user.email}}</p>
          </div>
          <div class="basic max-w-14rem w-full">
            <span class="head text-sm font-medium m-0">Phone</span>
            <p class="m-0 text-base">{{user.profile.contact.home}}</p>
          </div>
          <div class="basic max-w-14rem w-full">
            <span class="head text-sm font-medium m-0">Location</span>
            <p class="m-0 text-base">{{user.profile.contact.city}} {{user.profile.contact.city?',':''}} {{user.profile.contact.state}} {{user.profile.contact.zipCode}}</p>
          </div>
        </div>
      </div>  
      @if (isPwcEnabled){
        <div class="col-12 pb-4">
          <div class="wrap-details border-1 p-3 border-gray-200 flex">
              <div class="basic max-w-20rem w-full email-container">
                <span class="head text-sm font-medium m-0">PwC email
                  @if(currentUserisFMOrPM()){
                    <p-button class="vert-align-top" size="small" pTooltip="Edit" tooltipPosition="top" (click)="editUserDetails(userProfileEditTypes.pwcEmail)" [rounded]="true" [text]="true" icon="true">
                      <span class="{{helperService.getEnvironmentName()}}-icon icon-edit-outlined"></span>
                    </p-button>
                  }
                </span>
                
                <p class="m-0 text-base">{{user.pwcEmail}}</p>
              </div>  
              <div class="basic max-w-14rem w-full">
                <span class="head text-sm font-medium m-0">{{'Standard pay rate' | sentenceCase}}</span>
                @if(currentUserisFMOrPM()){
                  <p-button class="vert-align-top" size="small" pTooltip="Edit" tooltipPosition="top" (click)="editUserDetails(userProfileEditTypes.primaryPayRate)" [rounded]="true" [text]="true" icon="true">
                    <span class="{{helperService.getEnvironmentName()}}-icon icon-edit-outlined"></span>
                  </p-button>
                }
                <p class="m-0 text-base">${{user.profile.primaryPayRate.toFixed(2)}}</p>
              </div>  
            @if (user.profile.secondaryPayRate) {
              <div class="basic max-w-14rem w-full">
                <span class="head text-sm font-medium m-0">{{'Foreign language rate' | sentenceCase}}</span>
                @if(currentUserisFMOrPM()){
                  <p-button class="vert-align-top" size="small" pTooltip="Edit" tooltipPosition="top" (click)="editUserDetails(userProfileEditTypes.secondaryPayRate)" [rounded]="true" [text]="true" icon="true">
                    <span class="{{helperService.getEnvironmentName()}}-icon icon-edit-outlined"></span>
                  </p-button>
                }
                <p class="m-0 text-base">${{user.profile.secondaryPayRate.toFixed(2)}}</p>
              </div>  
            }
            <div class="basic max-w-14rem w-full">
              <span class="head text-sm font-medium m-0">Ranking</span>
              @if(currentUserisFMOrPM()){
                <p-button class="vert-align-top" size="small" pTooltip="Edit" tooltipPosition="top" (click)="editUserDetails(userProfileEditTypes.ranking)" [rounded]="true" [text]="true" icon="true">
                  <span class="{{helperService.getEnvironmentName()}}-icon icon-edit-outlined"></span>
                </p-button>
              }
              <p class="m-0 text-base">{{user.profile.ranking}}</p>
            </div>  
            
            @if (user.profile.guid) {
              <div class="basic max-w-12rem w-full">
                <span class="head text-sm font-medium m-0">GUID</span>
                @if(currentUserisFMOrPM()){
                  <p-button class="vert-align-top" size="small" pTooltip="Edit" tooltipPosition="top" (click)="editUserDetails(userProfileEditTypes.guid)" [rounded]="true" [text]="true" icon="true">
                    <span class="{{helperService.getEnvironmentName()}}-icon icon-edit-outlined"></span>
                  </p-button>
                }
                <p class="m-0 text-base">{{user.profile.guid}}</p>
              </div>  
            }
            @if (user.profile.contractorNumber) {
              <div class="basic max-w-12rem w-full">
                <span class="head text-sm font-medium m-0">Contractor Number</span>
                @if(currentUserisFMOrPM()){
                  <p-button class="vert-align-top" size="small" pTooltip="Edit" tooltipPosition="top" (click)="editUserDetails(userProfileEditTypes.contractorNumber)" [rounded]="true" [text]="true" icon="true">
                    <span class="{{helperService.getEnvironmentName()}}-icon icon-edit-outlined"></span>
                  </p-button>
                }
                <p class="m-0 text-base">{{user.profile.contractorNumber}}</p>
              </div>  
            }
            @if (user.profile.secondaryContractorNumber) {
              <div class="basic max-w-16rem w-full">
                <span class="head text-sm font-medium m-0">Secondary Contractor Number</span>
                @if(currentUserisFMOrPM()){
                  <p-button class="vert-align-top" size="small" pTooltip="Edit" tooltipPosition="top" (click)="editUserDetails(userProfileEditTypes.secondaryContractorNumber)" [rounded]="true" [text]="true" icon="true">
                    <span class="{{helperService.getEnvironmentName()}}-icon icon-edit-outlined"></span>
                  </p-button>
                }
                <p class="m-0 text-base">{{user.profile.secondaryContractorNumber}}</p>
              </div>  
            }
            @if (!user.profile.secondaryPayRate){
              <p-button class="vert-align-top" size="small" pTooltip="Add foreign language rate" tooltipPosition="top" (click)="allowFieldOptions()" [rounded]="true" [text]="true" icon="true">
                <span class="{{helperService.getEnvironmentName()}}-icon icon-more-outlined"></span>
              </p-button>
            }
          </div>
        </div>
      }
      @if(user.profile.educations.length > 0){
        <div class="col-12 pb-3">
          <span class="text-xl font-medium m-0"> Education </span>
        </div>
        <div class="col-12 pb-4">
          @for (education of user.profile.educations; track education){
            <div class="wrap-details border-1 p-3 border-gray-200 flex justify-content-between align-items-center">
              <div class="basic">
                <span class="desc text-sm font-medium m-0">{{education.school.name}}</span>
                <p class="m-0 text-base head">
                  {{education.degree.type}}
                </p>
                <span class="text-sm m-0">{{education.school.startDate | date:'yyyy'}} - {{education.school.endDate |
                  date:'yyyy'}}</span>
              </div>
            </div>
          }
        </div>
      }
      <div class="col-12 pb-3">
        <span class="text-xl font-medium m-0"> {{'Candidate Details' | sentenceCase}} </span>
      </div>
      @if(!currentUser.firm.isSingleSearchMarketEnabled && user.profile.searchMarkets.length > 0){
        <div class="pr-10 xl:col-6 lg:col-6 col-12 pb-4">
          <span class="text-xl font-medium m-0"> {{'Search Markets' | sentenceCase}} </span>
          @if(currentUserisFMOrPM()){
            <p-button class="vert-align-top" size="small" pTooltip="Edit" tooltipPosition="top" (click)="editUserDetails(userProfileEditTypes.searchMarket)" [rounded]="true" [text]="true" icon="true">
              <span class="{{helperService.getEnvironmentName()}}-icon icon-edit-outlined"></span>
            </p-button>
          }
          <div class="data-table">
            <p-table styleClass=""
              [value]="user.profile.searchMarkets" 
              [rows]="5"
              [paginator]="true"
              currentPageReportTemplate=""
              alwaysShowPaginator="false"
              autoLayout="true">
              <ng-template pTemplate="body" let-searchMarket>
              <tr>
                <div class="wrap-details border-1 p-3 border-gray-200 flex justify-content-between align-items-center">
                  <div class="basic">
                    <p class="m-0 text-base head">{{searchMarket.name}}</p>
                  </div>
                </div>
              </tr>
              </ng-template>
            </p-table>
          </div>
        </div>  
      }
      @if(!currentUser.firm.isSingleJobTypeEnabled && user.profile.jobCategories.length > 0){ 
        <div class="pl-10 xl:col-6 lg:col-6 col-12 pb-4">
          <span class="text-xl font-medium m-0"> {{'Job Types' | sentenceCase}} </span>
          @if(currentUserisFMOrPM()){
            <p-button class="vert-align-top" size="small" pTooltip="Edit" tooltipPosition="top" (click)="editUserDetails(userProfileEditTypes.jobType)" [rounded]="true" [text]="true" icon="true">
              <span class="{{helperService.getEnvironmentName()}}-icon icon-edit-outlined"></span>
            </p-button>  
          }
          <div class="data-table">
            <p-table styleClass=""
              [value]="user.profile.jobCategories" 
              [rows]="5"
              [paginator]="true"
              currentPageReportTemplate=""
              alwaysShowPaginator="false"
              autoLayout="true">
              <ng-template pTemplate="body" let-jobCategory>
              <tr>
                <div class="wrap-details border-1 p-3 border-gray-200 flex justify-content-between align-items-center">
                  <div class="basic">
                    <p class="m-0 text-base head">{{jobCategory.name}}</p>
                  </div>
                </div>
              </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      }
      @if(user.profile.credentials.length || reviewerInactiveCredentials.length){
        <div class="col-12 pb-3">
          <span class="text-xl font-medium m-0"> Credentials </span>
          @if(currentUserisFMOrPM()){
            @if(user.profile.credentials.length > 0){
              <p-button class="vert-align-top" size="small" pTooltip="Edit" tooltipPosition="top" (click)="showCredentialsEdit()" [rounded]="true" [text]="true" icon="true">
                <span class="{{helperService.getEnvironmentName()}}-icon icon-edit-outlined"></span>
              </p-button>
            }
            @if(reviewerInactiveCredentials.length){
              <p-button (click)="showRemovedCredentials()" [label]="'View Removed Credentials' | sentenceCase" [rounded]="true" size="small" class="ml-2 fl-end" />
            }
            <p-button (click)="addNewCredential()" [label]="'Add New Credentials' | sentenceCase" [rounded]="true" size="small" class="fl-end" />
          }
        </div>
      }
      @if(user.profile.credentials.length > 0){
        <div class="col-12 pb-4">
          @for (cred of user.profile.credentials; track cred){
            <div class="wrap-details border-1 p-3 border-gray-200 flex justify-content-between align-items-center">
              <div class="basic">
                <p class="m-0 text-base head">{{cred.name}}</p>
                <p class="m-0 text-base desc">{{cred.secondaryOptions}}</p>
              </div>
              @if(!cred.isReviewerActivated){
                <p-tag value="Inactive" [rounded]="true" class="pillInactive cursor-pointer"/>
              }
              @if(showEditCredentials){
                <div class="flex align-items-center">
                  <p-button size="small" pTooltip="Edit" tooltipPosition="top" (click)="editCredential(cred)" [rounded]="true" [text]="true" icon="true">
                    <span class="{{helperService.getEnvironmentName()}}-icon icon-edit-outlined"></span>
                  </p-button>
                  <p-button size="small" pTooltip="Deactivate" tooltipPosition="top" (click)="editCredentials(cred._id)" [rounded]="true" [text]="true" icon="true">
                    <span class="{{helperService.getEnvironmentName()}}-icon icon-close-outlined"></span>
                  </p-button>
                </div>
              }
            </div>
          }
        </div>
      }

      @if(reviewerInactiveCriteria.length || (user.profile.criterias.length && hasAnySelectedCriteria() )){
        <div class="col-12 pb-3">
          <span class="text-xl font-medium m-0">{{'Skills And Experience' | sentenceCase}} </span>
          @if(currentUserisFMOrPM()){
            @if(reviewerInactiveCriteria.length){
              <p-button (click)="showRemovedSkills()" [label]="'View Removed Skills' | sentenceCase" [rounded]="true" size="small" class="ml-2 fl-end" />
            }
            <p-button (click)="addNewSkills()" [label]="'Add/edit Skills' | sentenceCase" [rounded]="true" size="small" class="fl-end" />
          }
        </div>
      }

      @if(user.profile.criterias.length > 0 && hasAnySelectedCriteria()){
        
        <div class="col-12">
          @for (cred of user.profile.criterias; track cred){
            @if(cred.criteriaSelectedOptions){
              <div class="wrap-details border-1 p-3 border-gray-200 flex justify-content-between align-items-center">
                <div class="basic">
                  <p class="m-0 text-base head">{{cred.criteriaName}}</p>
                  <p class="m-0 text-base desc">{{cred.criteriaSelectedOptions}}</p>
                </div>
                @if(showEditSkillExperience){
                  <p-button size="small" pTooltip="Deactivate" tooltipPosition="top" (click)="editSkillExperience(cred._id)" [rounded]="true" [text]="true" icon="true">
                    <span class="{{helperService.getEnvironmentName()}}-icon icon-close-outlined"></span>
                  </p-button>  
                }
              </div>
            }
          }
        </div>
      }
      
      @if(user.profile.barAdmissions.length > 0){
        <div class="col-12 pb-3">
          <span class="text-xl font-medium m-0"> {{'Bar Membership' | sentenceCase}} </span>
        </div>
        @for (bar of user.profile.barAdmissions; track bar){
          <div class="col-12 pb-4">
            <div class="wrap-details border-1 p-3 border-gray-200 flex justify-content-between align-items-center">
              <div class="basic">
                <span class="head text-sm font-medium m-0">State</span>
                <p class="m-0 text-base">{{bar.skill.name}}</p>
              </div>
              <div class="basic">
                <span class="head text-sm font-medium m-0">Membership</span>
                <p class="m-0 text-base">{{bar.code}}</p>
              </div>
              <span class="verified px-2 py-1 border-1 border-round-2xl h-fit">
                {{status(bar)}}
              </span>
            </div>
          </div>
        }
      }

      <div class="col-12 pt-3 pb-3">
        <span class="text-xl font-medium m-0"> {{'Current Projects' | sentenceCase}}</span>
      </div>
      @if(currentProjectsLoaded){
        <div class="col-12 pr-4">
          <p-table styleClass="p-datatable-sm p-datatable-sm--normal" [value]="currentProjects" autoLayout="true">
            <ng-template pTemplate="header">
              <tr>
                <th>
                  Project
                </th>
                <th>
                  Role
                </th>
                <th>
                  {{'Acceptance Date' | sentenceCase}}
                </th>
                <th>
                  {{'Start Date' | sentenceCase}}
                </th>
                <th>
                  Status
                </th>
                
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-currentProject>
              <tr>
                <td>{{currentProject.project.codeName}}</td>
                <td>{{currentProject.role.roleType}}</td>
                @if(currentProject.isPresumptivelyPending){
                  <td></td>
                  <td>{{currentProject.positionStarted | date: "MM/dd/yyyy" : 'UTC'}}</td>
                  <td>Pending</td>
                }
                @else {
                  <td>{{currentProject.updatedAt | date: "MM/dd/yyyy" : 'UTC'}}</td>
                  @if(currentProject.isFuture){
                    <td>{{currentProject.role.startAt | date: "MM/dd/yyyy" : 'UTC'}}</td>
                  }
                  @else {
                    <td>{{currentProject.positionStartDate | date: "MM/dd/yyyy" : 'UTC'}}</td>
                  }
                  <td>Staffed</td>  
                }
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-currentProject>
              <tr>
                <td [attr.colspan]="6" class="text-center">
                  {{'No Current Project Available' | sentenceCase}}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      }
      @else {
        <div class="px-5 w-full">
          <p-skeleton styleClass="mb-2" />
          <p-skeleton styleClass="mb-2" />
        </div>
      }

      <div class="col-12 pt-3 pb-3">
        <span class="text-xl font-medium m-0"> {{'Past Projects' | sentenceCase}}</span>
      </div>
      @if(pastProjectsLoaded){
        <div class="col-12 pr-4">
          <p-table styleClass="p-datatable-sm p-datatable-sm--normal" [value]="pastProjects" autoLayout="true">
            <ng-template pTemplate="header">
              <tr>
                <th>
                  Project
                </th>
                <th>
                  Roles
                </th>
                <th>
                  {{'Acceptance Date' | sentenceCase}}
                </th>
                <th>
                  Ended
                </th>
                
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-pastProject>
              <tr>
                <td>{{pastProject.project.codeName}}</td>
                <td>{{pastProject.role.roleType}}</td>
                <td>{{pastProject.updatedAt | date: "MM/dd/yyyy" : 'UTC'}}</td>
                <td>Completed <span ng-if="proj.finishedAt">on
                    {{pastProject.finishedAt | date: "MM/dd/yyyy" : 'UTC' }}</span></td>
      
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-pastProject>
              <tr>
                <td [attr.colspan]="6" class="text-center">
                  {{'No Past Project Available' | sentenceCase}}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      }
      @else {
        <div class="px-5 w-full">
          <p-skeleton styleClass="mb-2" />
          <p-skeleton styleClass="mb-2" />
        </div>
      }

      <div class="col-12 mt-3 pb-3">
        <span class="text-xl font-medium m-0"> {{'Project Documents' | sentenceCase}}</span>
      </div>
      @if(docuSignDocumentsLoaded){
        <div class="col-12 pb-4">
          <p-table styleClass="p-datatable-sm p-datatable-sm--normal" [value]="docuSignDocuments">
            <ng-template pTemplate="header">
              <tr>
                <th>
                  Project
                </th>
                <th>
                  Roles
                </th>
                <th>
                  Template
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-docuSignDocument>
              <tr>
                <td>{{docuSignDocument.project.codeName}}</td>
                <td>{{docuSignDocument.role.roleType}}</td>
                <td>
                  <ul>
                    @for(template of docuSignDocument.templates; track template){
                    <li>
      
                      <span> {{template.name}} </span>
                      <ul>
                        @for(doc of template.documents; track doc){
                        <li>
                          <span> {{doc.name}} </span>
                          <span (click)="openDocuSignDocument(docuSignDocument.envelopeId, doc.documentId, doc.name)" 
                          class="{{helperService.getEnvironmentName()}}-icon icon-download-outlined"></span>
                        </li>
                        }
                      </ul>
                    </li>
                    }
      
                  </ul>
      
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-docuSignDocument>
              <tr>
                <td [attr.colspan]="6" class="text-center">
                  {{'No Project Documents Available' | sentenceCase}}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      }
      @else {
        <div class="px-5 w-full">
          <p-skeleton styleClass="mb-2" />
          <p-skeleton styleClass="mb-2" />
        </div>
      }
    </div>
  </div>
  <div class="col-12 xl:col-4 pt-3">
    @if(!isAdminApprovalPending){
      <div class="card border-round-sm py-3 px-5 shadow-3 w-full mb-4">
        <h6 class="mt-0 mb-3">{{'Talent Pools assigned' | sentenceCase}}</h6>
        @if(talentPoolsLoaded){
          @for (tp of talentPoolAssigned; track tp){
          <div class="data mb-3">
            <p class="m-0 desc">
              Name: {{tp.name}}
            </p>
            <p class="m-0 desc">
              Description: {{tp.description}}
            <p class="m-0 desc">
              Firm: {{tp.firm}}
            </p>
          </div>
          }
        }
        @else {
          <p-skeleton styleClass="mb-2" />
          <p-skeleton styleClass="mb-2" />
        }
  
        <p-button [disabled]="currentTenant.isDeleted" (onClick)="showTalentPool()" label="add to talent pool" [rounded]="true" icon="pi pi-plus" size="large" styleClass="vibrant-pink-background" class="mt-3" />
      </div>
    }
    @if(user.documents && user.documents.length){
      <div class="card border-round-sm py-3 px-5 shadow-3 w-full mb-4">
        <h6 class="mt-0 mb-2">Documents</h6>
        <div class="data mt-1">
          <ul class="list-none my-3 flex flex-column row-gap-2">
            @for (document of user.documents; track document){
              <li><a class="desc break-word merge-link" target="_self" (click)="getDocumentPathById(document._id)" >{{document.title}}</a></li>
            }
          </ul>
        </div>
      </div>
    }
    @if(!isAdminApprovalPending){

      <div class="card border-round-sm py-3 px-5 shadow-3 w-full mb-4">
        <h6 class="mt-0 mb-2">{{'Firm Uploaded Documents' | sentenceCase}}</h6>
        <div class="data mt-1">
          <ul class="list-none my-3 flex flex-column row-gap-2">
            @for (document of firmReviewerDocuments; track document){
            @if(document.url){
            <li>
              <a class="desc break-word" target="_self" [href]="document.url">{{document.title}} </a>
              <input type="file" #editDocu style="display: none"
                (change)="editDocument($event, 'FIRM_REVIEWER_DOCUMENT',document)">
              <span (click)="editDocu.click()" class="cursor-pointer {{helperService.getEnvironmentName()}}-icon icon-edit-outlined"></span>
              <span (click)="deleteDocment(document._id,false)" class="cursor-pointer {{helperService.getEnvironmentName()}}-icon icon-delete-outlined red"></span>
            </li>
            }
  
            }
          </ul>
          <input type="file" #documents style="display: none"
            (change)="onUploadDocument($event, 'FIRM_REVIEWER_DOCUMENT')">
          <p-button (click)="documents.click()" label="add additional document" [rounded]="true" icon="pi pi-plus"
            size="large" class="flex justify-content-center" />
        </div>
      </div>
      @if(firm && firm.isBackgroundCheckRequired){
        <div class="card border-round-sm py-3 px-5 shadow-3 w-full mb-4">
          <h6 class="mt-0 mb-2">{{'Background Check Status' | sentenceCase}}</h6>
          <div class="mt-3 flex align-items-center gap-2">
            <span class="{{helperService.getEnvironmentName()}}-icon icon-person-search-outlined" 
              [ngClass]=
              "{
                  'freshgreen' : user.profile.criminalCheck.secureBackgroundResult === secureBackgroundStatus.meetsRequirement,
                  'light-grey' : user.profile.criminalCheck.secureBackgroundResult === secureBackgroundStatus.na || user.profile.criminalCheck.secureBackgroundResult === secureBackgroundStatus.needsFurtherReview,
                  'red': user.profile.criminalCheck.secureBackgroundResult === secureBackgroundStatus.doesntMeetsRequirement
              }"
              ></span> <span> {{(user.profile.criminalCheck.secureBackgroundResult === secureBackgroundStatus.meetsRequirement? 'Meets Requirements' : user.profile.criminalCheck.secureBackgroundResult === secureBackgroundStatus.needsFurtherReview || user.profile.criminalCheck.secureBackgroundResult === secureBackgroundStatus.doesntMeetsRequirement ? 'Requires Additional Review' : 'No Result') | sentenceCase }} </span>
          </div>
        </div>
      }

      <div class="card border-round-sm py-3 px-5 shadow-3 w-full mb-4">
        <h6 class="mt-0 mb-2">{{'Database Status' | sentenceCase}}</h6>
        <div class="data mt-1">
          <span>You can deactivate a candidate at any time. Inactive candidates do not count toward your total candidate allotment</span>
        </div>
        <p-inputSwitch  [(ngModel)]="user.status" (ngModelChange)="onStatusToggleSwitch($event,user)" class="mpl-switch right-align" inputId="stfProject" ariaLabel="My Projects" />
      </div>
    }
    @if(!isAdminApprovalPending){
      <div class="card border-round-sm py-3 px-5 shadow-3 w-full mb-4">
        <h6 class="mt-0 mb-2">Notes</h6>
        <textarea [(ngModel)]="newNote" [maxlength]="maxLength" class="h-auto" rows="5" cols="30"
        [placeholder]="'Write Note...' | sentenceCase " pInputTextarea>
            </textarea>
        <p-button label="add note" [disabled]="!newNote" (onClick)="addNote()" [rounded]="true" size="large"
          class="flex justify-content-center" />
  
        @for (note of user.notes; track note){
        <div class="notes p-3 mt-1 border-round-sm">
          <span class="head text-xs block font-bold">Posted by: </span>
          <span class="head text-xs block font-bold">{{note.createdBy.firstName}} {{note.createdBy.lastName}} on
            {{note.createdAt | date :'mediumDate' }}</span>
          <p class="m-0 text-base break-word">{{ note.message}}</p>
        </div>
        }
      </div>

      @if(isPwcEnabled){
        @if(currentTenant.experience){
          <div class="card border-round-sm py-3 px-5 shadow-3 w-full mb-4">
            <h6 class="mt-0 mb-2">Experience note</h6>
            <div class="notes p-3 mt-1 border-round-sm">
              
              <p class="m-0 text-base break-word">{{ currentTenant.experience}}</p>
            </div>
          </div>
        }

        @if(currentTenant.recentFeedback){
          <div class="card border-round-sm py-3 px-5 shadow-3 w-full mb-4">
            <h6 class="mt-0 mb-2">Recent feedback</h6>
            <div class="notes p-3 mt-1 border-round-sm">
              <p class="m-0 text-base break-word">{{ currentTenant.recentFeedback}}</p>
            </div>
          </div>
        }

      }
    }
  </div>
 
  
 <!--  <div class="col-12 p-0">
    <p-button label="generate resume" [rounded]="true" size="large" />
  </div> -->
</div>
}
@if(showTalentPoolListing){

<app-add-to-talent-pool-list (back)="showTalentPool()" [firmId]="currentUser.firm._id"
  [reviewerId]="config.data.reviewerId"></app-add-to-talent-pool-list>
}
}
